import { render, staticRenderFns } from "./layerWms.vue?vue&type=template&id=606c4c29"
import script from "./layerWms.vue?vue&type=script&lang=js"
export * from "./layerWms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports